import { getApiBaseUrl, getApiClient } from "./serviceconfig";

var apiBaseUrl = getApiBaseUrl();

export async function getSalesInvoiceEinvoiceConfig(cookies, plant_id, invoice_date, invoice_amt = 0, billing_gst_no = '') {
    const gstParam = billing_gst_no ? `&billing_gst_no=${encodeURIComponent(billing_gst_no)}` : '';
    let url = `${apiBaseUrl}/sales_invoices/einvoice_config/?plant_id=${plant_id}&invoice_date=${invoice_date}&invoice_amt=${invoice_amt || 0}${gstParam}`;
    return getApiClient(cookies).get(url).then(response => response.data);
}

export async function getDirectInvoiceEinvoiceConfig(cookies, plant_id, invoice_date, invoice_amt = 0, billing_gst_no = '') {
    const gstParam = billing_gst_no ? `&billing_gst_no=${encodeURIComponent(billing_gst_no)}` : '';
    let url = `${apiBaseUrl}/direct_invoices/einvoice_config/?plant_id=${plant_id}&invoice_date=${invoice_date}&invoice_amt=${invoice_amt || 0}${gstParam}`;
    return getApiClient(cookies).get(url).then(response => response.data);
}

export async function generateSalesEinvoice(cookies, invoiceId) {
    return getApiClient(cookies)
        .post(`${apiBaseUrl}/sales_invoices/${invoiceId}/generate_einvoice/`)
        .then(response => response.data);
}

export async function generateDirectEinvoice(cookies, invoiceId) {
    return getApiClient(cookies)
        .post(`${apiBaseUrl}/direct_invoices/${invoiceId}/generate_einvoice/`)
        .then(response => response.data);
}
